<template>
    <svg viewBox="0 0 14 14" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7 13.5C10.5898 13.5 13.5 10.5898 13.5 7C13.5 3.41023 10.5898 0.5 7 0.5M7 13.5C3.41023 13.5 0.5 10.5898 0.5 7C0.5 3.41023 3.41023 0.5 7 0.5M7 13.5C8.5 13.5 10 10.5455 10 7C10 3.45455 8.5 0.5 7 0.5M7 13.5C5.5 13.5 4 10.5455 4 7C4 3.45455 5.5 0.5 7 0.5M1.09091 9.36364H12.9091M1.09091 4.63636H12.9091"
            stroke="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: "LanguageIcon",
};
</script>
